export default __webpack_public_path__ + "static/media/tiffi_thumb.026bc1d7.jpg";